// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/audit.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { SearchAuditEventsRequest, SearchAuditEventsResponse } from "./audit_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.AuditService
 */
export const AuditService = {
  typeName: "tracker.v1.AuditService",
  methods: {
    /**
     * @generated from rpc tracker.v1.AuditService.SearchAuditEvents
     */
    searchAuditEvents: {
      name: "SearchAuditEvents",
      I: SearchAuditEventsRequest,
      O: SearchAuditEventsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

